import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  Col,
  Form,
  FormCheck,
  FormLabel,
  ProgressBar,
  Row,
} from "react-bootstrap";
import Flex from "../../common/Flex";
import CardDropdown from "../../common/CardDropdown";
import IconItem from "../../common/icon/IconItem";
import classNames from "classnames";
import SikkaCardHeader from "../../common/SikkaCardHeader";

const APIAccessItem = ({
  item,
  index,
  handleChange,
  selectedApiNames,
  method,
  disableApiAccessSelection,
}) => {
  return (
    <>
      <FormCheck
        className="mb-0 d-flex align-items-baseline"
        type="checkbox"
        id={`${method}-${index}`}
        defaultChecked={selectedApiNames?.includes(item)}
        onChange={(e) => handleChange(item, e.target.checked)}
        disabled={
          selectedApiNames.includes(item) ? false : disableApiAccessSelection
        }
      />
      <FormCheck.Label className="flex-1 mb-0 ms-3">{item}</FormCheck.Label>
    </>
  );
};

const APIAccessListItem = ({
  data,
  handleChange,
  selectedApiNames,
  method,
  disableApiAccessSelection,
  selectedApiNamesForOtherApis,
}) => {
  return (
    <div>
      {data?.v2 || data?.auth || data?.payment || data?.v4 || data?.common ? (
        <Row className="overflow-auto" style={{ height: "200px" }}>
          <Col className="overflow-auto pl-4" sm={4}>
            <h6 className="text-primary mb-2">V2 APIs</h6>
            {data?.v2?.map((api, index) => {
              return (
                <APIAccessItem
                  index={index}
                  key={index}
                  item={api}
                  handleChange={handleChange}
                  selectedApiNames={selectedApiNames}
                  method={method}
                  disableApiAccessSelection={disableApiAccessSelection}
                />
              );
            })}
            <h6 className="text-primary mb-2 mt-1">KPIs</h6>
            {data?.kpis?.map((api, index) => {
              return (
                <APIAccessItem
                  index={index}
                  key={index}
                  item={api}
                  handleChange={handleChange}
                  selectedApiNames={selectedApiNames}
                  method={method}
                  disableApiAccessSelection={disableApiAccessSelection}
                />
              );
            })}
            <div className="mt-3">
              <h6 className="text-primary mb-2">Auth APIs</h6>
              {data?.auth?.map((api, index) => {
                return (
                  <APIAccessItem
                    index={index}
                    key={index}
                    item={api}
                    handleChange={handleChange}
                    selectedApiNames={selectedApiNames}
                    method={method}
                    disableApiAccessSelection={disableApiAccessSelection}
                  />
                );
              })}
            </div>

            <div className="mt-3 mb-3">
              <h6 className="text-primary mb-2">Payment APIs</h6>
              {data?.payment?.map((api, index) => {
                return (
                  <APIAccessItem
                    index={index}
                    key={index}
                    item={api}
                    handleChange={handleChange}
                    selectedApiNames={selectedApiNames}
                    method={method}
                    disableApiAccessSelection={disableApiAccessSelection}
                  />
                );
              })}
            </div>
          </Col>
          <Col className="overflow-auto pl-4" sm={4}>
            <h6 className="text-primary mb-2">V4 APIs</h6>
            {data?.v4?.map((api, index) => {
              return (
                <APIAccessItem
                  index={index}
                  key={index}
                  item={api}
                  handleChange={handleChange}
                  selectedApiNames={selectedApiNames}
                  method={method}
                  disableApiAccessSelection={disableApiAccessSelection}
                />
              );
            })}
          </Col>
          <Col className="overflow-auto mt-3 mt-sm-0 pl-4" sm={4}>
            <h6 className="text-primary mb-2">Common APIs</h6>
            {data?.common?.map((api, index) => {
              return (
                <APIAccessItem
                  index={index}
                  key={index}
                  item={api}
                  handleChange={handleChange}
                  selectedApiNames={selectedApiNames}
                  method={method}
                  disableApiAccessSelection={disableApiAccessSelection}
                />
              );
            })}
          </Col>
        </Row>
      ) : (
        <Row className="overflow-auto" style={{ height: "200px" }}>
          <Col className="overflow-auto pl-4" sm={4}>
            {data?.length > 0 ? (
              <h6 className="text-primary mb-2">Select APIs</h6>
            ) : (
              <div />
            )}
            {data?.map((api, index) => {
              return (
                <APIAccessItem
                  index={index}
                  key={index}
                  item={api}
                  handleChange={handleChange}
                  selectedApiNames={selectedApiNames}
                  method={method}
                  disableApiAccessSelection={disableApiAccessSelection}
                />
              );
            })}
          </Col>
        </Row>
      )}
    </div>
  );
};

APIAccessListItem.propTypes = {
  item: PropTypes.shape({
    task: PropTypes.string.isRequired,
    completed: PropTypes.bool.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }),
  index: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default APIAccessListItem;
